/**
 * STAC Browser config — tuiles servies par titiler-pgstac (lecture S3 côté serveur).
 *
 * Rebuild l'image stac-browser si vous changez TITILER_PUBLIC_URL.
 */
// const TITILER_PUBLIC_URL = "http://stac.unepgrid.ch:8089";
const TITILER_PUBLIC_URL = "https://titiler.unepgrid.ch";

function isGeoRasterAsset(asset) {
  const mediaType = (asset.type || "").toLowerCase();
  if (
    mediaType.includes("json") ||
    mediaType.includes("parquet") ||
    mediaType.includes("zarr")
  ) {
    return false;
  }
  return asset.isCOG || asset.isGeoTIFF;
}

function titilerRenderQuery(asset) {
  const params = new URLSearchParams();
  params.set("assets", asset.getKey());

  const bands = asset["raster:bands"] || [];
  const hasRgb = Boolean(asset.findVisualBands?.());

  // Mono-bande : colormap requis pour un rendu visible (comme votre URL /searches/...).
  if (!hasRgb && bands.length <= 1) {
    const stats = bands[0]?.statistics;
    if (stats?.minimum != null && stats?.maximum != null) {
      params.set("rescale", `${stats.minimum},${stats.maximum}`);
      params.set("colormap_name", "rdylgn");
    }
  }

  return params.toString();
}

export default {
  catalogUrl: "https://stac-api.unepgrid.ch",
  // catalogUrl: "http://stac.unepgrid.ch:8080",
  catalogTitle: "UNEP Grid STAC",
  locale: "fr",
  fallbackLocale: "fr",

  useTileLayerAsFallback: false,
  displayPreview: true,
  displayOverview: true,

  // rio-stac ne met pas de rôles sur le COG ; ol-stac n'affiche que visual/overview.
  preprocessSTAC: (stac) => {
    if (!stac?.isItem || !stac.assets) {
      return stac;
    }

    for (const asset of Object.values(stac.assets)) {
      if (!isGeoRasterAsset(asset)) {
        continue;
      }
      const roles = new Set(asset.roles || []);
      roles.add("data");
      roles.add("visual");
      asset.roles = [...roles];
    }

    return stac;
  },

  buildTileUrlTemplate: (asset) => {
    const item = asset.getContext();
    if (!item || item.getObjectType?.() !== "Item") {
      return null;
    }

    const collectionId = item.collection;
    const itemId = item.id;
    const assetKey = asset.getKey();
    if (!collectionId || !itemId || !assetKey) {
      return null;
    }

    if (!isGeoRasterAsset(asset)) {
      return null;
    }

    const base =
      `${TITILER_PUBLIC_URL}/collections/${encodeURIComponent(collectionId)}` +
      `/items/${encodeURIComponent(itemId)}/tiles/WebMercatorQuad/{z}/{x}/{y}.png`;

    return `${base}?${titilerRenderQuery(asset)}`;
  },
};
